var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.456,
    height: 18.257,
    viewBox: "0 0 16.456 18.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bell",
    d: "M11.624,11.937a2.331,2.331,0,0,1-.708-.964,11.159,11.159,0,0,1-.738-4.41c0-.006,0-.011,0-.017a4.256,4.256,0,0,0-2.505-3.86V1.671A1.671,1.671,0,0,0,6,0H5.865A1.671,1.671,0,0,0,4.2,1.671V2.686A4.256,4.256,0,0,0,1.692,6.563a11.159,11.159,0,0,1-.738,4.41,2.331,2.331,0,0,1-.708.964.427.427,0,0,0-.235.486.447.447,0,0,0,.441.343H3.672a2.263,2.263,0,0,0,4.525,0h3.221a.447.447,0,0,0,.441-.343A.427.427,0,0,0,11.624,11.937ZM5.076,1.671A.791.791,0,0,1,5.865.88H6a.791.791,0,0,1,.789.791V2.4a4.256,4.256,0,0,0-1.717,0v-.73ZM5.935,14.12a1.387,1.387,0,0,1-1.383-1.353H7.318A1.387,1.387,0,0,1,5.935,14.12ZM7.7,11.886H1.453a4.606,4.606,0,0,0,.23-.4,11.126,11.126,0,0,0,.888-4.919,3.364,3.364,0,1,1,6.728,0c0,.005,0,.011,0,.016a11.1,11.1,0,0,0,.888,4.9,4.609,4.609,0,0,0,.23.4Z",
    transform: "translate(5.376) rotate(21)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b1da8af7.svg";
export { ForwardRef as ReactComponent };